import request from '@/utils/request'
const BASE_URL = '/Msg'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  listWithRoles(data) {
    return request({
      url: BASE_URL + '/ListWithRoles',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  update(data) {
    return request({
      url: BASE_URL + '/Update',
      method: 'post',
      data
    })
  },
  delete(id) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data: { id }
    })
  },
}